import { Outlet } from 'react-router-dom';
import Header from './header/Header';
import './App.css';
import License from './license/License';
import { isCN } from './locale';
import { useLenis } from './hooks/useLenis';

function App() {
  // 启用 Lenis 平滑滚动
  useLenis();

  return (
    <div className="App">
      <Header /> 
      <Outlet />
      {isCN() && <License />}
    </div>
  );
}

export default App;
